<template>
	<div class="bar">
		<div class="bar_one">
			<div class="one_left">
				<img class="yali" src="@/assets/home/yali.png" alt="" />
				<div class="one_max">
					<div class="one_max_num">
						{{this.$store.state.max}}
					</div>
					<div class="one_max_name">
						<span v-if="lang==0">最大承载量(人)</span>
						<span v-if="lang==1">Maximum(person)</span>
						<span v-if="lang==2">さいだいしじょうりょう</span>
						<span v-if="lang==3">최대 적재량 (사람)</span>
					</div>
				</div>
				<div class="er-box">
					<img class="erwei" src="@/assets/home/erwei.jpg" alt="" />
					<div class="er_name">
						<span v-if="lang==0">【扫码关注公众号】</span>
						<span v-if="lang==1">【official account】</span>
						<span v-if="lang==2">【公衆番号】</span>
						<span v-if="lang==3">【공중번호】</span>
					</div>
				</div>
			</div>
			
			<div class="bar_optbox">
				<div class="bar_opt" @click="barfun(0)">
					<img class="vr_img" src="@/assets/home/VR.png" alt="" />
					<div class="opt_name">
						<div class="opt_name_cn">
							<span v-if="lang==0">虚拟景区</span>
							<span v-if="lang==1">Virtual scenic spots</span>
							<span v-if="lang==2">仮想観光地</span>
							<span v-if="lang==3">가상 관광지</span>
						</div>
						<div class="opt_name_en">
							720°VR
						</div>
					</div>
				</div>
				
				<div class="bar_opt" @click="barfun(1)">
					<img class="kefu_img" src="@/assets/home/kefu.png" alt="" />
					<div class="opt_name">
						<div class="opt_name_cn">
							<span v-if="lang==0">咨询热线</span>
							<span v-if="lang==1">Consultation hotline</span>
							<span v-if="lang==2">問い合わせホットライン</span>
							<span v-if="lang==3">상담 핫라인</span>
						</div>
						<div class="opt_name_en">
							Consultation hotline
						</div>
					</div>
				</div>
				
				<div class="bar_opt" @click="barfun(2)">
					<img class="news_img" src="@/assets/home/news.png" alt="" />
					<div class="opt_name">
						<div class="opt_name_cn">
							<span v-if="lang==0">新闻动态</span>
							<span v-if="lang==1">News updates</span>
							<span v-if="lang==2">ニュースの動き</span>
							<span v-if="lang==3">뉴스 동향</span>
						</div>
						<div class="opt_name_en">
							News updates
						</div>
					</div>
				</div>
				
				<div class="bar_opt" @click="barfun(3)" v-if="lang==0">
					<img class="yuding_img" src="@/assets/home/yuding.png" alt="" />
					<div class="opt_name">
						<div class="opt_name_cn">
							<span >门票预订</span>
						</div>
						<div class="opt_name_en">
							Ticket booking
						</div>
					</div>
				</div>
				
			</div>
			<div class="multicolour"></div>
		</div>
		<div class="bar_tow">
			<div class="tow_left">
				<div>
					<span v-if="lang==0">景区地址：重庆市开州区人和街东侧260米</span>
					<span v-if="lang==1">Scenic Area Address: 260 meters east of Renhe Street, Kaizhou District, Chongqing</span>
					<span v-if="lang==2">観光地住所：重慶市開州区人と街の東側260メートル</span>
					<span v-if="lang==3">관광지 주소: 충칭시 카이저우구 런허거리 동쪽 260m</span>
				</div>
				
				<div>
					<span v-if="lang==0">咨询电话： {{this.$store.state.consulting}} | </span> 
					<span v-if="lang==1">Consultation： {{this.$store.state.consulting}} | </span> 
					<span v-if="lang==2">コンサルティング： {{this.$store.state.consulting}} | </span> 
					<span v-if="lang==3">컨설팅： {{this.$store.state.consulting}} | </span> 
					
					
					<span v-if="lang==0">救援电话： {{this.$store.state.rescue}} | </span>
					<span v-if="lang==1">Rescue： {{this.$store.state.rescue}} | </span>
					<span v-if="lang==2">救援電話： {{this.$store.state.rescue}} | </span>
					<span v-if="lang==3">구조 전화： {{this.$store.state.rescue}} | </span>
					
					
					<span v-if="lang==0">投诉电话：{{this.$store.state.complain}} </span>
					<span v-if="lang==1">Complaint：{{this.$store.state.complain}} </span>
					<span v-if="lang==2">クレーム電話：{{this.$store.state.complain}} </span>
					<span v-if="lang==3">신고 전화：{{this.$store.state.complain}} </span>
					
					
					<span v-if="lang==0" @click="nuv()">全国旅游监管服务平台：12345</span>
					<span v-if="lang==1" @click="nuv()">National Tourism Supervision Service Platform：12345</span>
					<span v-if="lang==2" @click="nuv()">全国観光規制サービスプラットフォーム：12345</span>
					<span v-if="lang==3" @click="nuv()">전국 관광 감독 관리 서비스 플랫폼：12345</span>
					
				</div>
			</div>
			
			<div class="tow_right">
				<div>CopyRight © 2024 qicairenhe All Rights Reserved.Design</div>
				<div>
					<span @click="rescue()">
						<span v-if="lang==0">by:至上互动 </span>
						<span v-if="lang==1">by:Supreme interaction </span>
						<span v-if="lang==2">by:上位インタラクション </span>
						<span v-if="lang==3">by:최상의 상호 작용 </span>
					</span>
				 
					<span @click="ban()">
						<span v-if="lang==0"> ICP:渝ICP备2024033467号-1</span>
						<span v-if="lang==1"> ICP:Chongqing ICP No. 2024033467-1</span>
						<span v-if="lang==2"> ICP:渝ICP備2024033467号-1</span>
						<span v-if="lang==3"> ICP:유ICP비 2024033467호-1</span>
					</span>
				</div>
			</div>
		</div>
		
		<!--  -->
		<div class="riesun" v-if="riesunfalg" @click="close()">
			<div class="riesun_box">
				<img class="riesun_img" src="../assets/home/riesun.png" alt="">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				riesunfalg:false,
				
				lang: 0, //语言
				
			}
		},
		created() {
			this.lang = JSON.parse(localStorage.getItem("langs")) || 0;
			
		},
		methods:{
			nuv(){		//服务平台
				window.open('https://jbts.mct.gov.cn/',"_blank");
			},
			ban(){		//备案
				window.open('https://beian.miit.gov.cn/#/Integrated/index',"_blank");
			},
			
			// 名片
			rescue(){
				this.riesunfalg = true
			},
			close(){
				this.riesunfalg = false
			},
			
			barfun(e){
				if(e==0){
					window.open('https://www.720yun.com/vr/c45j5Owkvn8',"_blank");
				}
				if(e==1){
					if(this.$route.name == 'contact'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'contact',query:{}})
					}
				}
				if(e==2){
					if(this.$route.name == 'news'){
						this.$router.push({name:'refresh',query:{}})
					}else{
						this.$router.push({name:'news',query:{}})
					}
				}
				if(e==3){
					if(this.$route.name == 'book'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'book',query:{}})
					}
				}
			},
			
			
		}
	}
</script>

<style scoped lang="less">
	.bar{
		width: 1920px;
		height: 162px;
		position: absolute;
		bottom: 0;
		left: 0;
		z-index: 10;
	}
	.bar_one{
		height: 92px;
		font-size: 0;
		display: flex;
		background-color: rgba(0, 0, 0, .5);
	}
	
	.one_left{
		width: 427px;
		height: 92px;
		background-image: url('@/assets/home/greed.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		display: flex;
		position: relative;
		padding-top: 1px;
		color: #fff;
	}
	.yali{
		width: 41px;
		height: 42px;
		margin: 25px 0 0 60px;
	}
	.one_max{
		width: 147px;
		height: 92px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.one_max_num{
		font-size: 30px;
		font-weight: bold;
	}
	.one_max_name{
		font-size: 14px;
	}
	.er-box{
		position: absolute;
		bottom: 5px;
		left: 247px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.erwei{
		width: 101px;
		height: 102px;
		
	}
	.er_name{
		font-size: 12px;
	}
	.bar_optbox{
		height: 92px;
		width: calc(100% - 497px);
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	.bar_opt{
		display: flex;
		align-items: center;
	}
	.vr_img{
		width: 56px;
		height: 38px;
	}
	.opt_name{
		margin-left: 22px;
		color: #fff;
	}
	.opt_name_cn{
		font-size: 18px;
		color: #fff;
	}
	.opt_name_en{
		font-size: 14px;
		text-transform:uppercase;
	}
	.kefu_img{
		width: 49px;
		height: 42px;
	}
	.news_img{
		width: 41px;
		height: 41px;
	}
	.yuding_img{
		width: 42px;
		height: 41px;
	}
	
	
	.multicolour{
		width: 70px;
		height: 92px;
		background-image: url('@/assets/home/multicolour.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	// 
	.bar_tow{
		height: 70px;
		background-color: #fff;
		box-sizing: border-box;
		padding: 0 60px;
		display: flex;
		align-items: center;
		color: #333333;
		justify-content: space-between;
	}
	.tow_left{
		font-size: 14px;
		line-height: 1.75em;
	}
	
	.tow_right{
		font-size: 14px;
		line-height: 1.75em;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}
	
	//
	.riesun{
		position: fixed;
		z-index: 1000;
		top: 0;
		left: 0;
		width: 1920px;
		height: 100vh;
		background-color: rgba(0, 0, 0, .5);
	}
	.riesun_box{
		width: 1000px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform:translate(-50%,-50%);
		background-color: #363636;
	}
	.riesun_img{
		width: 100%;
	}
</style>